import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, Redirect , NavLink, useHistory } from "react-router-dom";
import { setAlert } from "../../actions/alert";
import PropTypes from "prop-types";
import UserProfileNavLink from '../../components/userProfileNavLink/userprofilenavlink';
import Alert from '../../components/alert/Alert';
import { addHourlyRate } from "../../actions/freelancerProfile";
import InputRange from 'react-input-range';

const HourlyRate = ({ freelancerProfile : { hourlyRate, freelancerprofile } , setAlert, addHourlyRate, isAuthenticated}) => {

     let youReceive = 0;

     const [youReceiveVal, setYouReceiveVal] = useState();
     
     const [state, setstate] = useState({
      value: 50 
     });

    
     const [formData , setFormData] = useState({
      hourly_rate: ""
     });

     const handleInputChange = (value) => {
      setstate({ value }); // Update the state value
      const max = value; // Get the max value from the updated state
      setFormData({ ...formData, hourly_rate: String(max) });
      const youReceive = max * 0.1; // Calculate the value to subtract from the max
      setYouReceiveVal(max - youReceive); // Update the youReceiveVal state
    };

    useEffect(() => {
        document.title = 'Hourly Rate';
    }, []);

     useEffect(() => {
      let check = JSON.parse(localStorage.getItem('hourlyRate'));
      console.log(check)
      if(check)
      {
        setFormData(hourlyRate);
        youReceive = hourlyRate.hourly_rate * 0.2;
        setYouReceiveVal(hourlyRate.hourly_rate - youReceive);
      }
      
     }, []);

      const { hourly_rate } = formData;

      /*const onChange = (e) => {
        let value = e.target.value;
        setstate({ value});
      setFormData({ ...formData, [e.target.name]: e.target.value });
      youReceive = e.target.value * 0.2;
      setYouReceiveVal(e.target.value - youReceive);
    };*/

    const onChange = (e) => {
      const inputValue = e.target.value;
    
      // Extract the first part of the input as the numeric value
      const extractedValue = parseFloat(inputValue.split(" ")[0]);
    
      // Check if the extracted value is a valid number
      if (!isNaN(extractedValue)) {
        setstate({ value: extractedValue });
        setFormData({ ...formData, [e.target.name]: extractedValue });
        const youReceive = extractedValue * 0.2;
        setYouReceiveVal(extractedValue - youReceive);
      } else {
        // Handle invalid input (non-numeric)
        setstate({ value: "" });
        setFormData({ ...formData, [e.target.name]: "" });
        setYouReceiveVal(0);
      }
    };

   

  let history = useHistory();
  const regex = /^[0-9]+$/;

  const onSubmit = async (e) => {
    e.preventDefault();

    if (isNaN(youReceive)) {
      console.log("not a valid number");
      return;
    }

    // Check that Title and Professional Overview fields contain at least one letter
    /*if (!regex.test(hourly_rate) || !regex.test(hourlyRate)){
      setAlert("hourly rate must contain only numbers", "danger");
      console.log("hourly rate must contain only numbers")
      return;
    }*/

    if (!String(hourly_rate).match(regex)) {
      setAlert("Hourly rate must be a valid number", "danger");
      return;
  }

    addHourlyRate({
      hourly_rate
    });
  };

   if (!isAuthenticated) {
        return <Redirect to="/login" />;
    }
    if(typeof freelancerprofile === "string"){
      return <Redirect to="/expert-email-verify" />;
    }

  return (
    <section className="main-page page-dashboard">
      <div className="container">
        <div className="row">
          <div className="col-lg-3">
             <UserProfileNavLink />
          </div>
          <div className="col-lg-9">
              <div className="bg-white rounded shadow-sm sidebar-page-right">
                <div className="p-5 border-bottom">
                  <h3 className="text-primary">Hourly Rate</h3>
                  <p className="font-weight-bold">4 of 09</p>
                  <Alert />
                    <form onSubmit={(e) => onSubmit(e)}>
                      <p className="font-weight-bold">Our customers will see these rates when your profile matches their requirements. Make sure you create an impression.</p>
                        <div className="row d-flex align-items-center form-group">
                            <div className="col-md-12 col-12">
                                <p className="text-dark font-weight-bold mb-2">Hourly Rate</p>
                                <p className="text-muted mb-2">Total amount the client will see</p>
                            </div>
                            <div className="col-md-8 col-12">
                                <div className="form-group cyber-form-control">
                                    <div className="mt-2">
                                        <InputRange
                                            maxValue={500}
                                            minValue={10}
                                            value={state.value}
                                            onChange={handleInputChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-8 col-12">
                              <input type="text" className="form-control" placeholder="0.00 USD / hr"
                              name="hourly_rate"
                              value={hourly_rate + " USD"}
                              onChange={(e) => onChange(e)} />
                            </div>
                            <div className="col-md-12 col-12 mt-3">
                                <p className="text-dark font-weight-bold mb-1">CybertoCyber Service Fee</p>
                                <p className="text-muted mb-2">The CybertoCyber Service Fee is 20% when you begin a contract with a new client.</p>
                            </div>
                            <div className="col-md-8 col-12">
                              <input type="text" className="form-control" placeholder="20%" readOnly />
                            </div>
                            <div className="col-md-12 col-12 mt-3">
                                <p className="text-dark font-weight-bold mb-1">You'll receive</p>
                                <p className="text-muted mb-2">The estimated amount you'll receive after service fees</p>
                            </div>
                            <div className="col-md-8 col-12">
                              <input type="text" className="form-control" placeholder="$ 0.00 / hr" readOnly
                              name="youReceiveVal"
                              value={youReceiveVal  + " USD"} />
                            </div>
                            {/*<div className="col-md-8 col-12 pt-4">
                              <p className="font-weight-bold">What skills do you offer clients?</p>
                              <input type="text" className="form-control" placeholder="Enter at least 1 skill e.g Cyber Security, Mobile Cyber Security" />
                            </div>*/}
                            <div className="col-md-12 col-12 mt-4">
                              
                            </div>
                        </div>


                        <div className="row justify-content-center">
                          <div className="col">
                          {/*<Link to="/certificate" className="btn btn-normal">Skip this step</Link>*/}
                          </div>
                          <div className="text-right">
                            <Link to="/languages" className="btn btn-default mr-3">Back</Link>
                            
                            <button className="btn btn-primary" type="submit">Save</button>
                            <Link className="btn btn-primary ml-3" to="titleandoverview" >
                                Next
                            </Link>
                          </div>
                        </div>


                    </form>
                </div>
              </div>
          </div>
        </div>
      </div>
    </section>
  );
};

HourlyRate.propTypes = {
  isAuthenticated: PropTypes.bool,
};

const mapStateToProp = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  freelancerProfile: state.freelancerProfile
});


export default connect(mapStateToProp, { setAlert, addHourlyRate })(HourlyRate, Alert);